import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f3d651a6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "course-img"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "course-name text-overflow",
  id: "courseName"
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "course-name text-overflow",
  id: "courseName"
};
const _hoisted_9 = {
  class: "bottom"
};
const _hoisted_10 = {
  class: "teacher"
};
const _hoisted_11 = {
  class: "name"
};
const _hoisted_12 = {
  class: "name ml text-overflow"
};
const _hoisted_13 = {
  class: "time"
};
const _hoisted_14 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");

  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goDetail && $options.goDetail(...args)),
    class: "course-card"
  }, [$props.showResultTag && $props.courseData.results_id ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "tag-btn",
    style: _normalizeStyle({
      background: $props.resultMap[$props.courseData.results_id]
    })
  }, [_createElementVNode("span", null, _toDisplayString($props.courseData.results_name), 1)], 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.courseData.course_cover_url || require('@/assets/images/common/course_cover.png')
  }, null, 8, _hoisted_4)]), $props.courseData.classify_name ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_tooltip, {
    content: $props.courseData.course_name,
    placement: "top-start",
    effect: "light"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString($props.courseData.course_name), 1)]),
    _: 1
  }, 8, ["content"])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_tooltip, {
    content: $props.courseData.course_name,
    placement: "top-start",
    effect: "light"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString($props.courseData.course_name), 1)]),
    _: 1
  }, 8, ["content"])]))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($props.courseData.lecturer), 1), _createVNode(_component_el_tooltip, {
    content: $props.courseData.classify_name,
    placement: "top-start",
    effect: "light"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString($props.courseData.classify_name), 1)]),
    _: 1
  }, 8, ["content"])]), _createElementVNode("div", _hoisted_13, [$props.courseData.students_num ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($props.courseData.students_num) + "人参加", 1)) : _createCommentVNode("", true)])])])]);
}